<template>
  <v-app-bar-nav-icon @click="()=>this.$router.back()">
    <v-icon color="black">{{ mdiArrowLeft }}</v-icon>
  </v-app-bar-nav-icon>
</template>

<script>
import { mdiArrowLeft } from '@mdi/js'

export default {
  name: 'AppbarBackIcon',
  data() {
    return { mdiArrowLeft }
  },
}
</script>

<style>
</style>